const AH_CARD_SELECTOR = ".collection__main .product-card";
const ahSwipeStart = new WeakMap();

function ahHydrateProductGallery(card) {
  if (!card || card.classList.contains("is-gallery-ready")) return;

  const media = card.querySelector(".product-card__media");
  const template = media?.querySelector("template[data-ah-product-card-gallery]");

  if (!media || !template) return;

  media.append(template.content.cloneNode(true));
  template.remove();
  media.dataset.ahGalleryIndex = "0";
  card.classList.add("is-gallery-ready");
  ahUpdateGalleryControls(card, 0);
}

function ahUpdateGalleryControls(card, index) {
  const media = card.querySelector(".product-card__media");
  const images = media?.querySelectorAll(".product-card__image") || [];
  const previous = card.querySelector('[data-ah-gallery-direction="-1"]');
  const next = card.querySelector('[data-ah-gallery-direction="1"]');

  if (previous) previous.disabled = index <= 0;
  if (next) next.disabled = index >= images.length - 1;
}

function ahShowGalleryImage(card, requestedIndex) {
  ahHydrateProductGallery(card);

  const media = card.querySelector(".product-card__media");
  const imageCount = media?.querySelectorAll(".product-card__image").length || 0;

  if (!media || imageCount < 2) return;

  const index = Math.max(0, Math.min(requestedIndex, imageCount - 1));
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  media.dataset.ahGalleryIndex = String(index);
  media.scrollTo({ left: index * media.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
  ahUpdateGalleryControls(card, index);
}

function ahBuildFacetsUrl(form) {
  const facetsForm = form.closest("facets-form");
  const url = new URL(form.action, window.location.origin);
  const searchParams = new URLSearchParams(new FormData(form));

  url.search = "";
  searchParams.forEach((value, key) => url.searchParams.append(key, value));

  ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((key) => {
    if (url.searchParams.get(key) === "") url.searchParams.delete(key);
  });

  url.searchParams.set("section_id", facetsForm.getAttribute("section-id"));
  return url;
}

function ahSetFacetsResultCount(facetsForm, html) {
  const form = facetsForm.querySelector("form");
  const drawer = facetsForm.closest("facets-drawer");
  const label = drawer?.querySelector("[data-ah-facets-apply-label]");
  if (!form || !drawer || !label) return;

  const documentFragment = new DOMParser().parseFromString(html, "text/html");
  const previewLabel = documentFragment.querySelector("[data-ah-facets-apply-label]");

  if (!previewLabel) return;
  label.textContent = previewLabel.textContent.trim();
}

document.addEventListener("pointerover", (event) => {
  const media = event.target.closest(`${AH_CARD_SELECTOR} .product-card__media`);
  if (!media) return;

  const isDesktopPointer = window.matchMedia("(min-width: 700px) and (hover: hover) and (pointer: fine)").matches;
  if (isDesktopPointer || event.pointerType === "touch") ahHydrateProductGallery(media.closest(".product-card"));
}, { passive: true });

document.addEventListener("focusin", (event) => {
  const card = event.target.closest(AH_CARD_SELECTOR);
  if (card) ahHydrateProductGallery(card);
});

document.addEventListener("pointerdown", (event) => {
  const media = event.target.closest(`${AH_CARD_SELECTOR} .product-card__media`);
  if (!media) return;

  ahHydrateProductGallery(media.closest(".product-card"));
  ahSwipeStart.set(media, { x: event.clientX, y: event.clientY });
}, { passive: true });

document.addEventListener("pointerup", (event) => {
  const media = event.target.closest(`${AH_CARD_SELECTOR} .product-card__media`);
  const start = media && ahSwipeStart.get(media);
  if (!media || !start) return;

  if (Math.abs(event.clientX - start.x) > 8 && Math.abs(event.clientX - start.x) > Math.abs(event.clientY - start.y)) {
    media.dataset.ahSuppressClick = "true";
    window.setTimeout(() => delete media.dataset.ahSuppressClick, 350);
  }

  ahSwipeStart.delete(media);
}, { passive: true });

document.addEventListener("click", (event) => {
  const galleryButton = event.target.closest("[data-ah-gallery-direction]");

  if (galleryButton) {
    event.preventDefault();
    event.stopPropagation();

    const card = galleryButton.closest(".product-card");
    const media = card.querySelector(".product-card__media");
    const currentIndex = Number.parseInt(media.dataset.ahGalleryIndex || "0", 10);
    ahShowGalleryImage(card, currentIndex + Number(galleryButton.dataset.ahGalleryDirection));
    return;
  }

  const media = event.target.closest(`${AH_CARD_SELECTOR} .product-card__media`);
  if (media?.dataset.ahSuppressClick === "true") {
    event.preventDefault();
    event.stopPropagation();
  }
}, true);

document.addEventListener("scroll", (event) => {
  const media = event.target;
  if (!(media instanceof Element) || !media.matches(`${AH_CARD_SELECTOR} .product-card__media`)) return;
  if (!media.classList.contains("product-card__media") || media.clientWidth === 0) return;

  const card = media.closest(".product-card");
  const index = Math.round(media.scrollLeft / media.clientWidth);
  media.dataset.ahGalleryIndex = String(index);
  ahUpdateGalleryControls(card, index);
}, true);

document.addEventListener("facet:preview", (event) => {
  const facetsForm = event.target.closest("facets-drawer facets-form");
  const form = facetsForm?.querySelector("form");
  if (!facetsForm || !form) return;
  if (ahBuildFacetsUrl(form).toString() !== event.detail.url) return;

  ahSetFacetsResultCount(facetsForm, event.detail.html);
});
